import RegisterField, { FieldProps } from "../register-field";
import { Select, SelectProps } from "@/components/inputs";

export default function FormSelect({
    name,
    registerOptions,
    ...props
}: FieldProps<SelectProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <Select
            {...props}

            inputRef={field.ref}
            value={field.value}
            disabled={field.disabled}

            onValueChange={v => {
                field.handleChange(v);
                props.onValueChange && props.onValueChange(v);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}

FormSelect.Option = Select.Option;